import { PropertyViewModelPropertyChangedEventArgsInterface } from "@nts/std/interfaces";
import { ViewModelPropertyChangedEventArgs } from "./view-model-property-changed-event-args";

export class PropertyViewModelPropertyChangedEventArgs<TValue = any> extends ViewModelPropertyChangedEventArgs implements PropertyViewModelPropertyChangedEventArgsInterface<TValue> {
    value: TValue;
}
